module.exports = __webpack_public_path__ + "static/media/landing-image-1.318c6225.png";